module.exports = __webpack_public_path__ + "static/media/RE_CategoryIcons.be0d8ec3.png";